import { mapGetters } from "vuex"
import infobulle from "../common/Infobulle.vue"

export default {
  components: { infobulle },
  props: {
    code: String,
    champProp: Object,
    value: [String, Array, Boolean, Number],
    id: { type: String },
    rules : [],
  },
  data() {
    return {
      largeurMax: 270
    }
  },
  computed: {
    ...mapGetters(["champs"]),
    champ() {
      if (this.champProp) {
        return this.champProp
      }
      if (this.champs?.has(this.code)) {
        return this.champs.get(this.code)
      }
      return null
    },
    label() {
      return this.champ?.label ?? ""
    },
    largeurMaxEnPx() {
      return (this.champ?.largeurMaxEnPx || this.largeurMax) + "px"
    },
    libelleLong() {
      return this.champ?.libelleLong ?? ""
    },
    descriptionPopup() {
      return this.champ?.descriptionPopup ?? ""
    },
    regExValidation() {
      return this.champ?.regExValidation ?? ""
    },
    regExValidationMessage() {
      return this.champ?.regExValidationMessage ?? ""
    },
    champObligatoireMessage() {
      return this.champ?.champObligatoireMessage ?? ""
    },
    optionel() {
      return this.champ?.optionel
    },
    masque() {
      return this.champ?.masque ?? ""
    },
    typeDeChamp() {
      return this.champ?.typeDeChamp ?? "";
    },
    modeAffichageChamp() {
      return this.champ?.modeAffichageChamp ?? ""
    },
    idInner() {
      return this.id || "champ_" + Math.floor(Math.random() * 1000)
    },
    isDense() {
      return this.modeAffichageChamp.includes('DENSE')
    },
    isOutlined() {
      return this.modeAffichageChamp.includes('OUTLINED')
    },
    optionalRules() {
      return this.rules;
    },
  }
}